import { render } from "./TheStaleMetadataPage.vue?vue&type=template&id=9e7a381e&scoped=true"
import script from "./TheStaleMetadataPage.vue?vue&type=script&lang=js"
export * from "./TheStaleMetadataPage.vue?vue&type=script&lang=js"

import "./TheStaleMetadataPage.vue?vue&type=style&index=0&id=9e7a381e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e7a381e"]])

export default __exports__